<script>
  // User detail/show page — the rich record view (moved off the edit route). Account
  // + membership + store live in sidebar panels; the social dossier fills the body.
  // Exemplar for the detail page type (see the zupp-admin-design skill).
  import Layout from '../../layouts/layout.svelte'
  import PageHeader from '../../components/page_header.svelte'
  import DetailLayout from '../../components/detail_layout.svelte'
  import DetailPanel from '../../components/detail_panel.svelte'
  import PropertyRow from '../../components/property_row.svelte'
  import EmptyState from '../../components/empty_state.svelte'
  import { Button, Badge } from '../../components/ui'
  import { badgeFor } from '../../lib/ui/badges.js'
  import SocialTab from './social/social_tab.svelte'

  let { user = {}, dates = {}, back_url = '/users', edit_url = '', can_manage_users = false, can_manage_social = false, social = null } = $props()

  const sub = $derived(user.current_subscription)
  const subBadge = $derived(sub?.status ? badgeFor('subscription', sub.status) : null)

  const programs = $derived(user.programs || [])
</script>

<Layout>
  <PageHeader
    title={user.name || 'User'}
    back={back_url}
    breadcrumbs={[{ label: 'Users', href: back_url }, { label: user.name || 'User' }]}
  >
    {#snippet badges()}
      {#if subBadge}<Badge variant="neutral" class={subBadge.badgeClass}>{subBadge.label}</Badge>{/if}
    {/snippet}
    {#snippet actions()}
      {#if user.stripe_id}
        <Button
          variant="ghost"
          size="sm"
          icon="credit"
          external
          target="_blank"
          href={user.stripe_customer_url}
        >
          Stripe
        </Button>
      {/if}
      {#if can_manage_users}
        <Button variant="primary" size="sm" icon="edit" href={edit_url}>Edit</Button>
      {/if}
    {/snippet}
  </PageHeader>

  <DetailLayout>
    {#snippet body()}
      {#if can_manage_social && social}
        <SocialTab {social} />
      {:else if !can_manage_social}
        <EmptyState icon="lock" title="Social dossier hidden" description="Requires the Social permission to view this user's moments, friends, and reports." />
      {/if}
    {/snippet}

    {#snippet panels()}
      {#if can_manage_users}
        <DetailPanel title="Account">
          <PropertyRow label="Email">{user.email || '—'}</PropertyRow>
          <PropertyRow label="Phone">{user.phone || '—'}</PropertyRow>
          <PropertyRow label="Referral code">{user.referral_code || '—'}</PropertyRow>
          <PropertyRow label="Referrals">{user.referral_count ?? 0}</PropertyRow>
          <PropertyRow label="Programs">
            {#if programs.length}
              <span class="flex gap-1 justify-end flex-wrap">
                {#each programs as p}<Badge variant="accent" soft size="sm">{p}</Badge>{/each}
              </span>
            {:else}—{/if}
          </PropertyRow>
          <PropertyRow label="Joined">{dates.joined || '—'}</PropertyRow>
        </DetailPanel>
      {/if}

      <DetailPanel title="Membership">
        {#if sub}
          <PropertyRow label="Status">
            {#if subBadge}<Badge variant="neutral" size="sm" class={subBadge.badgeClass}>{subBadge.label}</Badge>{/if}
          </PropertyRow>
          {#if dates.trial_ends}<PropertyRow label="Trial ends">{dates.trial_ends}</PropertyRow>{/if}
          {#if dates.cancels}<PropertyRow label="Cancels">{dates.cancels}</PropertyRow>{/if}
          {#if dates.resumes}<PropertyRow label="Resumes">{dates.resumes}</PropertyRow>{/if}
        {:else}
          <p class="text-sm text-base-content/50 py-2">No subscription.</p>
        {/if}
      </DetailPanel>

      <DetailPanel title="Store">
        <PropertyRow label="Points">{(user.points ?? 0).toLocaleString()}</PropertyRow>
        <PropertyRow label="Redemptions">{user.total_redemptions ?? 0}</PropertyRow>
      </DetailPanel>
    {/snippet}
  </DetailLayout>
</Layout>
